import { Component, ElementRef, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { SlideDTO } from 'src/app/model/slideDTO.model';
import { SettingsService } from '@app/services/settings.service';
import { SLIDE_BUILDER_CONFIG } from '../../constants/injection-tokens';
import { SlideBuilderConfig } from '../../models/slide-builder-config';
import { SlideContentConfig } from '../../models/slide-text-content-config';
import { AnimationScope } from 'library-explorer';

@Component({
    selector: 'app-slide-text',
    templateUrl: './slide-text.component.html',
    styleUrls: ['./slide-text.component.scss'],
    standalone: false
})
export class SlideTextComponent implements OnInit, OnChanges {
  @Input() public slideData: SlideDTO;
  @Input() public isQuiz: boolean;
  @Input() public animationEnabled: boolean;

  public glossaryTooltipsEnabled = false;

  public perWordAnimation = false;
  public contentConfig!: SlideContentConfig;

  constructor(
    @Optional() @Inject(SLIDE_BUILDER_CONFIG) public config: SlideBuilderConfig,
    private readonly elementRef: ElementRef,
    private readonly settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.perWordAnimation = this.slideData.animationScope === AnimationScope.ITEM;
    this.setDefaultColor();
    this.buildContentConfig();

    this.settingsService.getSettings().subscribe(settings => {
      const glossaryFeatureEnabled = settings.features?.glossary;
      const contextEnabled = this.isQuiz
        ? settings.quiz.glossaryTooltipsEnabled
        : settings.lesson.glossaryTooltipsEnabled;

      const glossaryEnabled = this.config?.enableGlossaryTooltip && glossaryFeatureEnabled && contextEnabled;

      if (glossaryEnabled === this.glossaryTooltipsEnabled) {
        return;
      }

      this.glossaryTooltipsEnabled = glossaryEnabled;
      this.buildContentConfig();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.slideData && !changes.slideData.firstChange) {
      this.perWordAnimation = this.slideData.animationScope === AnimationScope.ITEM;
      this.buildContentConfig();
    }
  }

  private buildContentConfig(): void {
    this.contentConfig = {
      html: this.slideData?.description,
      glossaryEnabled: this.glossaryTooltipsEnabled,
      addaptFontSize: true,
      wordAnimation: this.perWordAnimation
        ? { animation: this.slideData?.animation, delay: this.slideData?.animationDelay }
        : undefined
    };
  }

  private setDefaultColor(): void {
    const color = this.slideData.defaultTextColor;
    if (!color) {
      return;
    }

   this.elementRef.nativeElement.style.setProperty('--lms-widget-text-color', color);
  }

}
